import { InputboxDate } from './../objects/inputbox-date';
import { InputboxNumber } from './../objects/inputbox-number';
import { AppTextArea } from './../objects/app-textarea';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { QuestionBase } from 'src/app/objects/question-base';
import { DropdownQuestion } from 'src/app/objects/question-dropdown';
import { InputboxText } from 'src/app/objects/inputbox-text';
import { InputboxEmail } from '../objects/inputbox-email';
import { InputboxCheckbox } from 'src/app/objects/inputbox-checkbox';

@Injectable()
export class QuestionService {
  questions: QuestionBase<string>[] = [];
  
  // TODO: get from a remote source of question metadata
  getQuestions(inputs) {
    
    for (var i = 0; i < inputs.length; i++) {
      var input;
      switch (inputs[i].type) {
        case "dropdown": {
          input = new DropdownQuestion({
            key: inputs[i].key,
            label: inputs[i].label,
            required: inputs[i].required,
            options: inputs[i].options,
            order: inputs[i].order
          });
          this.questions.push(input);
          break;
        }

        case "text": {

          input = new InputboxText({
            key: inputs[i].key,
            label: inputs[i].label,
            type: inputs[i].type,
            required: inputs[i].required,
            order: inputs[i].order
          });
          this.questions.push(input);
          break;
        }
        case "number": {

          input = new InputboxNumber({
            key: inputs[i].key,
            label: inputs[i].label,
            type: inputs[i].type,
            name: inputs[i].name,
            required: inputs[i].required,
            order: inputs[i].order,
            pattern: inputs[i].pattern
          });
          this.questions.push(input);
          break;
        }
        default: {
          //statements; 
          break;
        }
      }
    }
    return of(this.questions.sort((a, b) => a.order - b.order));
  }

  getInput(ip) {
    var input;
    switch (ip.type) {
      case "dropdown": {
        input = new DropdownQuestion({
          key: ip.key,
          label: ip.label,
          required: ip.required,
          name: ip.name,
          options: ip.options,
          order: ip.order
        });
        this.questions.push(input);
        break;
      }
      case "text": {
        input = new InputboxText({
          key: ip.key,
          label: ip.label,
          type: ip.type,
          name: ip.name,
          required: ip.required,
          order: ip.order
        });
        this.questions.push(input);
        break;
      }
      case "email": {
        input = new InputboxEmail({
          key: ip.key,
          label: ip.label,
          type: ip.type,
          name: ip.name,
          required: ip.required,
          order: ip.order
        });
        this.questions.push(input);
        break;
      }
      case "number": {
        input = new InputboxNumber({
          key: ip.key,
          label: ip.label,
          type: ip.type,
          name: ip.name,
          required: ip.required,
          order: ip.order,
          pattern: ip.pattern
        });
        this.questions.push(input);
        break;
      }
      case "phone": {
        input = new InputboxNumber({
          key: ip.key,
          label: ip.label,
          type: ip.type,
          name: ip.name,
          required: ip.required,
          order: ip.order,
          pattern: ip.pattern
        });
        this.questions.push(input);
        break;
      }
      case "date": {
        input = new InputboxDate({
          key: ip.key,
          label: ip.label,
          type: ip.type,
          name: ip.name,
          required: ip.required,
          order: ip.order,
          pattern: ip.pattern,
          maxDate: ip.maxDate
        });
        this.questions.push(input);
        break;
      }
      case "textarea": {
        input = new AppTextArea({
          key: ip.key,
          label: ip.label,
          rowcount:ip.rowcount,
          type: ip.type,
          name: ip.name,
          required: ip.required,
          order: ip.order,
          pattern: ip.pattern
        });
        this.questions.push(input);
        break;
      }
      case "checkbox": {
        input = new InputboxCheckbox({
          key: ip.key,
          label: ip.label,
          type: ip.type,
          name: ip.name,
          required: ip.required,
          order: ip.order
        });
        this.questions.push(input);
        break;
      }
      default: {
        //statements; 
        break;
      }
    }
    return input;
  }
}
